import Rules from "../rules.js";
import Utils from "../utils.js";

class PresDocumentation {
  constructor() {}
  setup() {
    window.Documentation = (hasResidency, group, country, higherEducation, lang) => (
      `
      ${Header(i18n.titleDocuments)}
      ${HelpText(lang)}
      ${Language(lang)}
      ${EducationSecondary(lang)}
      ${EducationHigher(country, higherEducation, lang)}
      ${DeadlineTranscripts(group, lang)}
      ${Financing(group, lang)}
      ${Identification(hasResidency, lang)}
      ${TranslationOfDocuments(lang)}
      ${Additional()}
      `
    )

    function HelpText(lang) {
      var html = "";
      var text = Fellestekst("dok-master-ledetekst", "dok-master-ledetekst", lang);
      if(text) html += text;
      return html;
    }

    function Language(lang) {
      var html = "";
      var text = Fellestekst("dok-master-sprakkrav", (App.program.fellestekst["opptak-master-sprakkrav"] === "master-opptak-sprak-tospraklig" ? "master-dok-sprak-tospraklige" : "master-dok-sprak-engelsk-min"), lang);
      if(text) html += AccordionHeader(i18n.language) + text;
      return html;
    }

    function EducationSecondary(lang) {
      var html = "";
      var text = Fellestekst("dok-master-utdanning", "master-dok-videregaende-skole-generell", lang);
      if(text) html += AccordionHeader(i18n.educationSecondary) + text;
      return html;
    }

    function EducationHigher(country, higherEducation, lang) {
      var html = "";

      var count = 0;
      var countries = [];
      for(var i = 0; i < higherEducation.length; i++) {
        var text = Fellestekst("dok-master-utdanning-land", "master-dok-utdanning-" + higherEducation[i], lang);
        if(text) {
          count++;
          countries.push({
            "name": App.countries[higherEducation[i]],
            "text": text
          })
        }
      }

      // Only show general text if one of the countries don't have own text
      if(count != higherEducation.length) {
        text = Fellestekst("dok-master-utdanning", "master-dok-hoyere-utd-generell", lang);
        if(text) html += text;
      }

      // Sort countries by full name
      if(countries.length) {
        countries.sort(function(a, b) {
          if(a.name < b.name) return -1;
          if(a.name > b.name) return 1;
          return 0;
        });
      }
      for(var i = 0; i < countries.length; i++) {
        html += countries[i].text;
      }

      if(html != "") html = AccordionHeader(i18n.educationHigher) + html;
      return html;
    }

    function DeadlineTranscripts(group, lang) {
      var html = "";
      if(Rules.showDeadlineTranscripts(group)) {
        if(App.program.programCode === "MFM2-EMHEM" && group === "UIOMASTER") {
          var text = Fellestekst("studiet-master-ettersending", "studiet-master-ettersending-EMHEM-" + group, lang);
        } else {
          var text = Fellestekst("studiet-master-ettersending", "studiet-master-ettersending-" + group, lang);
        }
        if(group === "SFMASTER") {
          if(text) html += AccordionHeader(i18n.deadlineTranscripts) + text;
        } else {
          if(text && (text.indexOf("###DATE-DOCUMENTATION-DEADLINE###") === -1 || App.date[0]["documentation-deadline"])) {
            html += AccordionHeader(i18n.deadlineTranscripts) + Utils.InfoDate(text, "###DATE-DOCUMENTATION-DEADLINE###", "documentation-deadline");
          }
        }
      }
      return html;
    }

    function Financing(group, lang) {
      var html = "";
      if(Rules.showFinancing(group) && App.program.programCode !== "IBSENONLINE") {
        if(Rules.showFinancingExtraEMHEM(group)) {
          var text = Fellestekst("dok-master-finansiering", "master-dok-finansiering-emhem-SFMASTER", lang);
          if(text) html += text;
        } else {
          var text = Fellestekst("dok-master-finansiering", "master-dok-finansiering", lang);
          if(text) html += text;
        }
      } else {
        if(Rules.showFinancingExtraEMHEM(group)) {
          var text = Fellestekst("dok-master-finansiering", "master-dok-finansiering-emhem", lang);
          if(text) html += text;
        }
      }
      if(html != "") html = AccordionHeader(i18n.financing) + html;
      return html;
    }

    function Identification(hasResidency, lang) {
      var html = "";
      if(Rules.showIdentification(hasResidency)) {
        var text = Fellestekst("dok-master-id-navn", "master-dok-id", lang);
        if(text) html += AccordionHeader(i18n.identification) + text;
      }
      return html;
    }

    function TranslationOfDocuments(lang) {
      var html = "";
      var text = Fellestekst("dok-master-sprakkrav", "master-dok-sprak-oversettelse", lang);
      if(text) html += AccordionHeader(i18n.translationOfDocuments) + text;
      return html;
    }

    function Additional() {
      var html = "";
      var text = HeaderDowngrade(App.program["dok-master-fri"]);
      if(text) html += AccordionHeader(i18n.additional) + text;
      return html;
    }

  }
}
export default new PresDocumentation;